module.exports = __webpack_public_path__ + "img/pfIcon.f6351238.svg";